import {RouterProvider} from 'react-router-dom'
import {StyleSheetManager, ThemeProvider} from 'styled-components'
import {getAppTheme, GlobalStyles} from '@/theme/theme.ts'
import {router} from './router.tsx'
import Toaster from './Toaster.tsx'
import {useEffect} from 'react'
import {useAuthStore} from './features/auth/store/store.ts'
import {userMe} from './features/auth/store/actions.ts'
import {Spinner} from './components/ui/spinner/Spinner.tsx'
import {Flexbox} from './components/ui/flexbox/FlexBox.tsx'

export default function App() {
    const themeName = 'light'
    const accessToken = useAuthStore(state => state.accessToken)
    const user = useAuthStore(state => state.user)

    useEffect(() => {
        if (accessToken) {
            void userMe()
        }
    }, [userMe, accessToken])

    return (
        <ThemeProvider theme={getAppTheme({name: themeName})}>
            <StyleSheetManager>
                <>
                    <Toaster />
                    <GlobalStyles />
                    {!user && accessToken ? (
                        <Flexbox justify="center" align="center" fullWidth style={{height: '100%'}}>
                            <Spinner size={32} />
                        </Flexbox>
                    ) : (
                        <RouterProvider router={router} />
                    )}
                </>
            </StyleSheetManager>
        </ThemeProvider>
    )
}
